import React, { useState } from 'react';
import Layout from "../../hocs/Layout";
import { motion } from 'framer-motion';
import axios from 'axios';
import { setAlert } from '../../redux/actions/alert';
import { connect } from 'react-redux';

function Contact({ setAlert }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  
  // filePreviews is an array of objects: { file, preview }
  const [filePreviews, setFilePreviews] = useState([]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const filesArray = Array.from(e.target.files);
    const previews = filesArray.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));
    setFilePreviews(previews);
  };

  const removeFile = (index) => {
    // Revoke the object URL to avoid memory leaks
    URL.revokeObjectURL(filePreviews[index].preview);
    const newPreviews = filePreviews.filter((_, i) => i !== index);
    setFilePreviews(newPreviews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('name', formData.name);
    data.append('email', formData.email);
    data.append('phone', formData.phone);
    data.append('message', formData.message);
    // Add each file to FormData
    filePreviews.forEach(item => {
      data.append('files', item.file);
    });
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contact/`, 
        data
      );
      setAlert(response.data.message, 'red');
      console.log(response.data);
      // Reset the form and file previews
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      filePreviews.forEach(item => URL.revokeObjectURL(item.preview));
      setFilePreviews([]);
    } catch (error) {
      console.error(error);
      setAlert('There was an error sending your message.', 'red');
    }
  };

  return (
    <Layout products={true}>
      <div className="bg-white min-h-screen py-8">
        <div className="max-w-6xl mx-auto px-4">
          <motion.h1
            className="text-3xl font-bold mb-8"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Contact Us
          </motion.h1>
          <motion.form 
            className="space-y-4" 
            onSubmit={handleSubmit}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <div>
              <label className="block mb-1">Name</label>
              <input 
                type="text" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded p-2"
                required
                autoComplete="off"
              />
            </div>
            <div>
              <label className="block mb-1">Email</label>
              <input 
                type="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded p-2"
                required
                autoComplete="off"
              />
            </div>
            <div>
              <label className="block mb-1">Phone</label>
              <input 
                type="tel" 
                name="phone" 
                value={formData.phone}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded p-2"
                autoComplete="off"
              />
            </div>
            <div>
              <label className="block mb-1">Message</label>
              <textarea 
                name="message" 
                value={formData.message}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded p-2"
                rows="4"
                required
                autoComplete="off"
              ></textarea>
            </div>
            <div>
              <label className="block mb-1">Attach Product Images</label>
              <input 
                type="file" 
                name="files" 
                onChange={handleFileChange}
                className="w-full"
                multiple
              />
            </div>
            {filePreviews.length > 0 && (
              <div className="mt-4">
                <h2 className="text-lg font-bold mb-2">Image Preview</h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {filePreviews.map((item, index) => (
                    <div key={index} className="relative">
                      <img 
                        src={item.preview} 
                        alt={`Preview ${index}`} 
                        className="w-full h-32 object-cover rounded" 
                      />
                      <button 
                        type="button" 
                        onClick={() => removeFile(index)}
                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full px-2 py-1 text-xs"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <motion.button 
              type="submit"
              className="bg-blue-500 text-white py-2 px-4 rounded"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Send
            </motion.button>
          </motion.form>
          {/* Direct email contact section */}
          <div className="mt-8">
            <h2 className="text-xl font-bold mb-2">Or contact us directly</h2>
            <p>
              If you prefer, you can also send an email directly to us at{' '}
              <a href="mailto:contact@histori.ai" className="text-blue-500">
                contact@histori.ai
              </a>.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { setAlert })(Contact);
